import { PaymentMethod } from '../enums/PaymentMethod';
import { ExpenseCategory } from '~/app/einvoicing/enums/ExpenseCategory';
import { ExpenseType } from '~/app/einvoicing/enums/ExpenseType';
import { BaseSchema, ModelType, type ToOneRelationship, type ToManyRelationship } from '~~/app/base/schemas/BaseSchema';

type ExpenseRelationships = {
    contact: ToOneRelationship<ModelType.CONTACTS>;
    worksite: ToOneRelationship<ModelType.WORKSITES>;
    pdf: ToOneRelationship<ModelType.PDFS>;
    currentEinvoicingReceiving: ToOneRelationship<ModelType.EINVOICING_RECEIVINGS>;
    expenseLines: ToManyRelationship<ModelType.EXPENSE_LINES>;
    modelEvents: ToManyRelationship<ModelType.MODEL_EVENTS>;
    modelFiles: ToManyRelationship<ModelType.MODEL_FILES>;
};
export type PaymentMeans = {
    account?: string;
    amount?: number;
    brancheCode?: string;
    code?: string;
    holder?: string;
    mandateId?: string;
    network?: string;
    paymentId?: string;
    sepaCreditorReference?: string;
};

export type PaymentTerms = {
    note?: string;
    terms?: string;
};
export type EinvoiceData = {
    paymentMeans?: PaymentMeans[];
    paymentTerms?: PaymentTerms;
    remainingBalance?: number;
    prepaidAmount?: number;
};

type ExpenseAttributes = {
    title: string;
    description: string;
    amount: number;
    total: number;
    subtotal: number;
    totalTax: number;
    date: string;
    expenseType: ExpenseType;
    expenseCategory: ExpenseCategory;
    paymentMethod: PaymentMethod;
    dueAt: string;
    isPaid: boolean;
    paymentMethodDetails: string;
    vatRate: number;
    einvoiceData: EinvoiceData | null;
};

type ExpenseMeta = {
    displayPrice: {
        subtotal: number;
        total: number;
        totalTax: number;
    };
    isDeletable: boolean;
};

export default class ExpenseSchema extends BaseSchema<ExpenseAttributes, ExpenseMeta, ExpenseRelationships> {
    protected type: ModelType = ModelType.EXPENSES;
}
